import { parsePermission } from "@complete-athlete/enums";

export type NavPermission = {
  action: string;
  subject: string;
};

export type NavItemLike = {
  permission?: NavPermission;
};

export type NavEntryLike = {
  permission?: NavPermission;
  items: NavItemLike[];
  to?: string;
};

export function hasPermissionInList(permissions: string[] | null, action: string, subject: string): boolean {
  if (!permissions) return false;

  return permissions.some((permission) => {
    const parsed = parsePermission(permission);
    if (parsed.action === "manage" && parsed.subject === "all") return true;
    if (parsed.action === "manage" && parsed.subject === subject) return true;
    return parsed.action === action && parsed.subject === subject;
  });
}

function passesNavPermission(permission: NavPermission | undefined, permissions: string[] | null): boolean {
  if (!permission) return true;
  return hasPermissionInList(permissions, permission.action, permission.subject);
}

/** Drop nav entries (and child items) the viewer lacks permission for. */
export function filterNavEntries<T extends NavEntryLike>(entries: T[], permissions: string[] | null): T[] {
  return entries
    .filter((entry) => passesNavPermission(entry.permission, permissions))
    .map((entry) => ({
      ...entry,
      items: entry.items.filter((item) => passesNavPermission(item.permission, permissions)),
    }))
    .filter((entry) => {
      if (entry.to) return true;
      return entry.items.length > 0;
    });
}
